<template>
  <div class="workGuideIndex">
<!--    <div>-->
<!--      <otherNav></otherNav>-->
<!--    </div>-->
    <!--
    <div id="nav" class="nav col-sm-12 sm-hide ">
      <div class="nav-body">
        <el-menu
            style="display: flex;justify-content: space-around;align-items: center;
            color: #fff;font-size: 18px;"
            :default-active="$route.path"
            class="el-menu-demo sm-font"
            mode="horizontal"
            @select="handleSelect"
            background-color="#2A82E4FF"
            text-color="#fff"
            active-text-color="#fff">
          <el-menu-item index="/">首页</el-menu-item>
          <el-submenu index="/resourceBase">
            <template slot="title">资源</template>
            <el-submenu index="/resourceBase/germplasm">
              <template slot="title">种质资源</template>
              <el-menu-item index="/resourceBase/germplasm/seed">种子</el-menu-item>
              <el-menu-item index="/resourceBase/germplasm/dna">DNA</el-menu-item>
              <el-menu-item index="/resourceBase/germplasm/driedLeaf">干燥叶片</el-menu-item>
              <el-menu-item index="/resourceBase/germplasm/germplasmAnimal">动物种质</el-menu-item>
            </el-submenu>
            <el-submenu index="/resourceBase/dnaBar">
              <template slot="title">DNA条形码</template>
              <el-menu-item index="/resourceBase/dnaBar/spineAnimal">脊椎动物</el-menu-item>
              <el-menu-item index="/resourceBase/dnaBar/vascularPlant">维管植物 (植物)</el-menu-item>
            </el-submenu>
            <el-submenu index="/resourceBase/list">
              <template slot="title">名录</template>
              <el-menu-item index="/resourceBase/list/protectList">高黎贡山国家重点保护野生植物名录</el-menu-item>
              <el-menu-item index="/resourceBase/list/uniqueList">高黎贡山特有植物名录</el-menu-item>
            </el-submenu>
            <el-submenu index="/resourceBase/workGuide">
              <template slot="title">工作指南</template>
              <el-menu-item index="/resourceBase/workGuide/management">种质资源采集和管理规范</el-menu-item>
              <el-menu-item index="/resourceBase/workGuide/filling">野外数据填写规范 (植物)</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="/dynamic">
            <template slot="title">动态</template>
            <el-menu-item index="/dynamic/information">动态资讯</el-menu-item>
            <el-menu-item index="/dynamic/progressWork">工作进展</el-menu-item>
          </el-submenu>
          <el-submenu index="/scientificResearch">
            <template slot="title">科考影像</template>
            <el-menu-item index="/scientificResearch/picture">图片</el-menu-item>
            <el-menu-item index="/scientificResearch/video">视频</el-menu-item>
          </el-submenu>
          <el-submenu index="/help">
            <template slot="title">帮助</template>
            <el-menu-item index="/help/problem">常见问题</el-menu-item>
            <el-menu-item index="/help/relationWe">联系我们</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    -->
<router-view></router-view>
  </div>
</template>

<script>
import otherNav from '@/components/navBar/otherNav'

export default {
  name: "workGuideIndex",
  components: {  otherNav },
  methods: {
    handleSelect(key, keyPath) {
      this.$router.push({path:key}).catch(err => {
        // console.log(err)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.workGuideIndex {

}
</style>